module.exports = __webpack_public_path__ + "static/media/no_data_gray.96128959.svg";